import React from "react";

const SearchIcon = (props) => (
  <svg
    width="30"
    height="27"
    viewBox="0 0 30 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_379:14117)">
      <path
        opacity="0.5"
        d="M9.91653 24.3406C15.3933 24.3406 19.8331 19.9008 19.8331 14.4241C19.8331 8.94735 15.3933 4.50757 9.91653 4.50757C4.43978 4.50757 0 8.94735 0 14.4241C0 19.9008 4.43978 24.3406 9.91653 24.3406Z"
        fill="#FEB348"
      />
      <path
        d="M28.5595 26.1436L20.1755 17.7597L20.0493 17.6064"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.15771 10.7639C7.15771 12.4376 7.82255 14.0427 9.006 15.2261C10.1895 16.4096 11.7946 17.0744 13.4682 17.0744"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6211 20.7347C18.0979 20.7347 22.5376 16.2949 22.5376 10.8181C22.5376 5.34139 18.0979 0.901611 12.6211 0.901611C7.14437 0.901611 2.70459 5.34139 2.70459 10.8181C2.70459 16.2949 7.14437 20.7347 12.6211 20.7347Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_379:14117">
        <rect width="29.4611" height="27" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SearchIcon;
